export default {
  11: '2.75rem',
  15: '3.75rem'
}
